<template>
  <div v-if="job.submissionRestricted" class="warning-submission">
    <div class="warning-text">
      <i class="las la-exclamation-circle"></i>
      <p class="warning-text-info">
        You can’t submit this job right now. Submissions are temporarily
        restricted due to high volume.
      </p>
    </div>
    <div
      v-if="!userGetUnrestrictedNotification && showNotify"
      class="warning-notification"
    >
      <i class="las la-bell"></i>
      <a class="warning-notification-link" @click="notifyJobAvailable"
        >Notify me when it’s available</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmissionRestrictedAlert',

  props: {
    csrfToken: {
      type: String,
      required: false,
      default: null,
    },
    job: {
      type: Object,
      required: true,
    },
    showNotify: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      userGetUnrestrictedNotification: this.job.userGetUnrestrictedNotification,
    }
  },

  methods: {
    async notifyJobAvailable() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          authenticity_token: this.csrfToken,
          job_id: this.job.id,
        }),
      }

      let url = `/jobs/${this.job.code}/job_unrestricted_notifications.json`

      const response = await fetch(url, requestOptions).then((response) =>
        response.json()
      )

      if (response.id) {
        this.userGetUnrestrictedNotification = true

        this.$toast.open({
          message: 'You will be notified when this job becomes available.',
          type: 'success',
          duration: 3000,
          dismissible: true,
          position: 'top-right',
        })
      } else {
        this.$toast.open({
          message:
            'Failed to subscribe for notification. Please try again later.',
          type: 'error',
          duration: 3000,
          dismissible: true,
          position: 'top-right',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.warning-submission {
  background-color: #fafafa;
  margin: 15px 0;
  padding: 30px 10px;

  @include sp {
    padding: 15px 8px;
  }

  .warning-text {
    display: flex;
    justify-content: center;

    .la-exclamation-circle {
      font-size: 20px;
      margin-right: 5px;
    }

    .warning-text-info {
      font-weight: 500;
    }

    @include sp {
      flex-direction: column;
      font-size: 13px;
      padding: 15px 5px;

      .la-exclamation-circle {
        font-size: 20px;
        margin-bottom: 5px;
        margin-right: 0;
        text-align: center;
      }

      .warning-text-info {
        text-align: center;
      }
    }
  }

  .warning-notification {
    display: flex;
    justify-content: center;
    margin-top: 12px;

    .la-bell {
      color: #3742fa;
      font-size: 17px;
      font-weight: 900;
      margin-right: 5px;
    }

    .warning-notification-link {
      color: #3742fa;
      text-decoration: underline;
    }

    @include sp {
      margin-top: 0;

      .warning-notification-link {
        font-size: 14px;
      }
    }
  }
}
</style>
